@if (paiPicture(); as pic) {
  <source [attr.srcset]="webpSrcSet()" type="image/webp" [attr.sizes]="sizesAttr()" />
  <source [attr.srcset]="defaultSrcSet()" [attr.sizes]="sizesAttr()" />

  <img
    (load)="onLoad()"
    [attr.src]="fallbackSrc()"
    [attr.alt]="pic.alt || null"
    [attr.aria-hidden]="!pic.alt || null"
    [attr.loading]="priority() ? 'eager' : 'lazy'"
    [attr.fetchpriority]="priority() ? 'high' : null"
    [style.object-position]="mode() === 'cover' ? imagePosition() : null"
  />
}
